export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

export const modalTypes = {
  NOTIFICATIONS_MODAL: 'NOTIFICATIONS_MODAL',
  COMPANY_PROFILE_MODAL: 'COMPANY_PROFILE_MODAL',
  CANDIDATE_PROFILE_MODAL: 'CANDIDATE_PROFILE_MODAL'
};
